import { PasswordReset } from 'ui/components/agent/patterns/PasswordReset/PasswordReset';

/**
 * パスワードリセットページ
 */
export const AgentUserPasswordReset: React.FC = () => {
    return <PasswordReset />;
};
